module.exports = __webpack_public_path__ + "img/rewise-logo.e62f89e3.svg";